The description type.

Currently, three identifiers are defined:

- `AdvertisementDetails` is the detailed description of the position that appears on the job ad.
- `SearchBulletPoint` is a highlight or selling point of the position that appears in search results.
  This will not appear on the job ad details page.
  The number of bullet points that a job can provide is based on the `AdvertisementProductFeatures`'s `searchBulletPoints.limit`.
- `SearchSummary` is a short description that appears in search results.
  This will not appear on the job ad details page.
